/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Done_Unavailable_SubInputs */

const en_funnel_done_unavailable_sub = /** @type {(inputs: Funnel_Done_Unavailable_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing was charged. See the plans available to your account.`)
};

const es_funnel_done_unavailable_sub = /** @type {(inputs: Funnel_Done_Unavailable_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se hizo ningún cargo. Consulta los planes disponibles para tu cuenta.`)
};

/**
* | output |
* | --- |
* | "Nothing was charged. See the plans available to your account." |
*
* @param {Funnel_Done_Unavailable_SubInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_done_unavailable_sub = /** @type {((inputs?: Funnel_Done_Unavailable_SubInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Done_Unavailable_SubInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_done_unavailable_sub(inputs)
	return en_funnel_done_unavailable_sub(inputs)
});